module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Key-1a5e22c329fff06d44d70191eed20d29.svg";